import posthog from 'posthog-js';

import { userCookies } from '@/shared/constants/constants';
import { getCookie } from '@/shared/utils/cookie';
import { notifyBugsnagWithContext } from '@/shared/utils/error';

import type { ConsentStatus, PostHogUserProperties } from './types';

export const parseConsentCookie = (): boolean => {
  try {
    const consentCookieValue = getCookie(userCookies.CONSENT_STATUS);

    if (!consentCookieValue) {
      return false;
    }

    const consentSettings: ConsentStatus | null =
      JSON.parse(consentCookieValue);
    return !!(consentSettings && consentSettings['PostHog.com']);
  } catch (error) {
    notifyBugsnagWithContext('Parsing consent settings for Posthog', error);
    return false;
  }
};

export const applyConsentSettings = (consentGiven: boolean): void => {
  if (consentGiven && posthog.has_opted_out_capturing()) {
    posthog.opt_in_capturing();
  } else if (!consentGiven && posthog.has_opted_in_capturing()) {
    posthog.opt_out_capturing();
  }
};

export const isPreferencesProcessingAllowed = (): boolean => {
  // Optional-call: a consent CMP can define window.Shopify.customerPrivacy before Shopify's real
  // Customer Privacy API resolves, so preferencesProcessingAllowed may not exist yet. Guard the
  // call (not just the object) so an early read fails closed (undefined -> false) instead of throwing.
  return !!window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.();
};

export const buildUserPropertiesWithConsent = (
  baseProperties: PostHogUserProperties,
  consentProperties: PostHogUserProperties
): PostHogUserProperties => {
  if (!isPreferencesProcessingAllowed()) {
    return baseProperties;
  }

  return {
    ...baseProperties,
    ...consentProperties
  };
};
